export const navLinks = [
  { id: "hot", label: "今日瓜场" },
  { id: "method", label: "推理工法" },
  { id: "topic", label: "深扒专题" },
  { id: "class", label: "显微镜课堂" },
  { id: "faq", label: "瓜友问答" },
  { id: "about", label: "关于我们" },
];

export const hotTopics = [
  { tag: "时间线", title: "一条迟到 43 分钟的航班，如何倒推出一整段行程闭环", heat: 9824, badge: "高烧" },
  { tag: "措辞学", title: "声明里的三个「我们」，藏着团队态度的分水岭", heat: 8711, badge: "解析" },
  { tag: "显微镜", title: "同款配饰的三次同框，是巧合还是隔空回应", heat: 7640, badge: "热门" },
  { tag: "数据流", title: "两场发布会点赞曲线断崖，背后经历了什么", heat: 6812, badge: "追踪" },
  { tag: "证据链", title: "一个像素级动图，把谣言钉死在证据墙上", heat: 5234, badge: "反转" },
  { tag: "视角差", title: "正主沉默的黄金 72 小时，圈内都在传什么", heat: 4488, badge: "观察" },
];

export const methods = [
  {
    icon: "ri-eye-line",
    step: "工法一",
    title: "吃瓜八卦推理",
    desc: "从已知信息出发，用「如果…那么…」的假设推演补全空缺，把零散爆料串成一条可验证的因果链。",
    points: ["假设先行", "反向求证", "结论留白"],
  },
  {
    icon: "ri-file-chart-line",
    step: "工法二",
    title: "吃瓜八卦分析",
    desc: "把情绪放回冰箱，拆出事实、观点与推测三层，逐条标注置信度，让每句话都挂在证据而不是直觉上。",
    points: ["事实分层", "标注来源", "区分推测"],
  },
  {
    icon: "ri-zoom-in-line",
    step: "工法三",
    title: "吃瓜八卦细节",
    desc: "时间戳、配饰、拍摄机位、被裁掉的边角…真正的信号往往藏在人人刷过的画面里，却几乎没人多看一眼。",
    points: ["回放原片", "比对同款", "留意剪裁"],
  },
  {
    icon: "ri-focus-3-line",
    step: "工法四",
    title: "吃瓜八卦显微镜",
    desc: "把 4K 画面拉到像素级，逐帧逐帧地看。一条褶皱、一枚反光、背景里一晃而过的人，都可能改写结论。",
    points: ["逐帧慢放", "像素比对", "光影还原"],
  },
  {
    icon: "ri-fingerprint-line",
    step: "工法五",
    title: "吃瓜八卦蛛丝马迹",
    desc: "证据从来不是从天而降，而是散落在账号、通告、行程与路人偶遇里。学会收集，才谈得上解读。",
    points: ["跨源取证", "时间对齐", "足迹拼图"],
  },
  {
    icon: "ri-node-tree",
    step: "工法六",
    title: "吃瓜八卦逻辑链",
    desc: "把碎片排成因果链条，每一个环节都要经得起「为什么」的追问。链条不断，结论才立得住。",
    points: ["链式排布", "断点标记", "闭环验证"],
  },
];

export const galleryCategories = ["全部", "时间线还原", "措辞解读", "画面显微镜", "数据追踪", "证据链复盘"];

export const galleryItems = [
  {
    id: 1,
    cate: "时间线还原",
    title: "一张迟到 43 分钟的航班，如何倒推出一整段行程闭环",
    excerpt: "当所有在场者都对一个半小时空档讳莫如深，航班系统的公开记录就成了唯一不撒谎的证人。我们把三次起飞、两次落地和一段未公开的路段逐段对齐。",
    tags: ["时间线", "行程闭环", "公开记录"],
    lv: "进阶",
    reads: "9.8k",
    date: "09-03",
    hours: "阅读 9 分钟",
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%20flatlay%20of%20airport%20boarding%20pass%2C%20paper%20maps%20and%20pinned%20route%20threads%20on%20a%20cream%20desk%2C%20soft%20morning%20light%2C%20cinnabar%20red%20accent%20objects%2C%20documentary%20photojournalism%20style%2C%20cohesive%20neutral%20background&width=720&height=520&seq=gua-topic-01&orientation=landscape",
  },
  {
    id: 2,
    cate: "措辞解读",
    title: "声明里的三个「我们」，藏着团队态度的分水岭",
    excerpt: "同一份官方声明，主语从公司到艺人再到工作室逐层切换。谁在说话、替谁说话、避开了谁，措辞本身已经把立场交代得明明白白。",
    tags: ["措辞学", "官方声明", "主语分析"],
    lv: "入门",
    reads: "8.1k",
    date: "09-01",
    hours: "阅读 6 分钟",
    img: "https://readdy.ai/api/search-image?query=Editorial%20composition%20of%20printed%20news%20paper%20sheets%20with%20red%20ink%20marker%20highlights%2C%20magnifying%20glass%20and%20pen%20on%20warm%20paper%20background%2C%20soft%20natural%20desk%20lighting%2C%20journalism%20documentary%20photography&width=720&height=520&seq=gua-topic-02&orientation=landscape",
  },
  {
    id: 3,
    cate: "画面显微镜",
    title: "同款配饰的三次同框，是巧合还是隔空回应",
    excerpt: "同一条项链在不同城市、不同月份的三次出现，被不少网友解读为「隔空对话」。我们逐帧比对材质、磨损与佩戴角度，看看推理究竟站不站得住。",
    tags: ["配饰学", "同款比对", "像素级"],
    lv: "进阶",
    reads: "7.6k",
    date: "08-28",
    hours: "阅读 8 分钟",
    img: "https://readdy.ai/api/search-image?query=Closeup%20macro%20of%20delicate%20gold%20chain%20necklace%20on%20cream%20fabric%2C%20warm%20soft%20lighting%2C%20fine%20detail%20shallow%20depth%20of%20field%2C%20minimalist%20editorial%20jewelry%20photography&width=720&height=520&seq=gua-topic-03&orientation=landscape",
  },
  {
    id: 4,
    cate: "数据追踪",
    title: "两场发布会点赞曲线断崖，背后经历了什么",
    excerpt: "同一账号前后两场发布会的实时互动曲线出现断崖式差异。数据不会演戏：我们把转发峰值、时段分布与取消关注节奏放在同一张表上对照。",
    tags: ["数据流", "互动曲线", "舆情"],
    lv: "高阶",
    reads: "6.2k",
    date: "08-24",
    hours: "阅读 7 分钟",
    img: "https://readdy.ai/api/search-image?query=Top%20down%20view%20of%20line%20charts%20and%20bar%20graphs%20drawn%20on%20paper%20notebook%20with%20red%20and%20green%20ink%2C%20calculator%20and%20coffee%20cup%2C%20warm%20desk%20tones%2C%20editorial%20data%20journalism%20style&width=720&height=520&seq=gua-topic-04&orientation=landscape",
  },
  {
    id: 5,
    cate: "证据链复盘",
    title: "一个像素级动图，把谣言钉死在证据墙上",
    excerpt: "一段被反复转发的「实锤」动图，最终败给了一组时间戳。我们完整复盘了谣言从诞生到退场的全流程，也把辨伪的方法一条条列给你。",
    tags: ["辟谣", "证据链", "复盘"],
    lv: "入门",
    reads: "5.2k",
    date: "08-20",
    hours: "阅读 5 分钟",
    img: "https://readdy.ai/api/search-image?query=Wall%20of%20printed%20photos%20connected%20by%20red%20and%20green%20strings%20with%20pins%2C%20detective%20conspiracy%20board%20style%2C%20warm%20ambient%20light%2C%20documentary%20moody%20photography&width=720&height=520&seq=gua-topic-05&orientation=landscape",
  },
  {
    id: 6,
    cate: "时间线还原",
    title: "一场同城「偶遇」直播，机位与字幕暴露了所有安排",
    excerpt: "所谓临时起意的街拍，从机位高度、补光角度到字幕措辞都透着设计感。我们把六个直播画面并排，逐秒对上了「巧合」的台词。",
    tags: ["直播拆解", "机位分析", "巧合?安排?"],
    lv: "进阶",
    reads: "7.3k",
    date: "08-16",
    hours: "阅读 10 分钟",
    img: "https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20on%20monitor%20with%20multiple%20camera%20angles%20in%20dark%20room%2C%20reflected%20warm%20light%2C%20documentary%20behind%20the%20scenes%20editorial%20photography&width=720&height=520&seq=gua-topic-06&orientation=landscape",
  },
];

export const classSteps = [
  {
    no: "01",
    title: "先清场，再上手",
    desc: "动手分析前先把情绪与预设立场清出桌面。你越想让某个结论成立，就越容易替它找证据。先写下「我目前最想要它是什么」。",
    icon: "ri-emotion-normal-line",
  },
  {
    no: "02",
    title: "给每句话贴标签",
    desc: "把看到的每一条信息分成事实、观点、推测与传闻四类，并标注来源层级：官方通报、一手影像、圈内传闻还是二手转述。",
    icon: "ri-price-tag-3-line",
  },
  {
    no: "03",
    title: "把时间轴拉平",
    desc: "所有线索最终都要回到同一条时间线上。先落时间点，再看因果顺序，先发生的事决定后发生的事，而不是反过来。",
    icon: "ri-timer-2-line",
  },
  {
    no: "04",
    title: "逐环节追问为什么",
    desc: "沿着你搭好的链条，对每个环节都追问一次「为什么/凭什么」。答不上来的环节先标红，不要用「大家都懂」糊弄过去。",
    icon: "ri-question-line",
  },
  {
    no: "05",
    title: "给结论留一扇门",
    desc: "真正的吃瓜高手从不把话说死。证据不足时大方承认「存疑」，比硬凑一个看似完整却站不住脚的故事，专业得多。",
    icon: "ri-door-open-line",
  },
];

export const tips = [
  "先定来源可信度，再看内容猎奇度",
  "官方从未回应的点，一律归为待定",
  "影像要追原始出片，不看二次剪辑",
  "多路信息对不上，先信时间戳最硬",
  "热度越高越要慢半拍，让子弹飞一会儿",
];

export const faqs = [
  {
    q: "吃瓜八卦推理和普通八卦有什么区别？",
    a: "普通八卦停留在「谁和谁怎样了」的信息层，而吃瓜八卦推理多走一步：它关心「你凭什么这么判断」。推理会把看到的碎片拆成事实、观点与推测，逐条追问依据，再把能对上号的证据排成一条逻辑链。也就是说，大家吃的是同一颗瓜，推理党吃的是「这颗瓜为什么长这样」。",
  },
  {
    q: "「显微镜」分析是不是就是在抠字眼、钻牛角尖？",
    a: "好的显微镜分析绝不是为抠而抠，而是把放大后看到的东西放回语境里检验。我们会问：这个细节在时间上立得住吗？来源可信吗？换个解释还成立吗？如果三关都过，它才有资格进入证据链；如果过不了，就该干脆利落地放下，而不是硬找补。",
  },
  {
    q: "分析会不会越来越像在替艺人「洗地」或「带节奏」？",
    a: "这是所有吃瓜分析都要警惕的红线。我们的原则是：只对证据负责，不对某个立场负责。同一颗瓜，如果分析指向A说法但证据指向B说法，我们会按证据说话，哪怕结论并不讨喜。立场会变，证据不会，这是吃瓜分析的立身之本。",
  },
  {
    q: "证据不足时你们会怎么处理？",
    a: "坦诚标注「存疑」比硬凑结论高级得多。我们会把信息分成已证实、基本可信、纯属猜测三档，并明确告诉你哪些环节还缺证据、补到什么样的证据才能让链条闭合。宁可留白，也不拿推测冒充实锤。",
  },
  {
    q: "普通人也能学会这种分析能力吗？",
    a: "完全可以。这套方法不需要任何专业背景，核心只有四件事：控制预设立场、给信息分层、拉齐时间轴、逐环节追问。我们在「显微镜课堂」里把这套流程拆成了可复制的步骤，跟着练上一段时间，你会发现自己看瓜的速度慢了，但看得准了。",
  },
];

export const testimonials = [
  {
    name: "柳晚",
    role: "入所 14 个月",
    text: "第一次有人告诉我「吃瓜也可以不下结论」。现在遇到大瓜我会先做事实分层，脑子清爽多了，群里吵架我也能把大家拽回证据上。",
    mark: "时间线爱好者",
  },
  {
    name: "周迟",
    role: "入所 8 个月",
    text: "「显微镜课堂」那套五步流程我抄成了便签贴在工位上。上次一次反转里，全组只有我用时间戳看出了破绽，别提多有面子了。",
    mark: "画面显微镜选手",
  },
  {
    name: "阿满",
    role: "入所 3 年",
    text: "这里最难得的不是「拆得快」，而是「敢承认不知道」。被证据说服、被自己推翻都是常事，但每次复盘完都会更接近真相一层。",
    mark: "证据链复盘员",
  },
];

export const whyItems = [
  { icon: "ri-discuss-line", title: "只讲证据的圈子", desc: "进入讨论前先过「事实分层」这一关，少一点口嗨，多一点依据。" },
  { icon: "ri-magic-line", title: "拆解而不定性", desc: "我们还原过程、追问逻辑，但绝不对任何人的人生下终审判决。" },
  { icon: "ri-team-line", title: "同频的瓜友", desc: "三万名把「为什么」挂在嘴边的同好，陪你从蛛丝马迹拆到逻辑闭环。" },
];